import React, {useState} from 'react';
import axios from "axios";
import authApi from "../../utils/authApi";

const SignIn = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await authApi.authenticate(email, password);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <form action="" onSubmit={handleLogin} id="sign-up-form">
            <h2 className="my-16 text-3xl text-center">Connexion</h2>
            <label htmlFor="email">Email</label>
            <br/>
            <input
                type="text"
                className="block border border-grey-light w-full p-3 rounded mb-16"
                name="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}/>
            <div className="email error"/>
            <br/>
            <label htmlFor="password">Mot de passe</label>
            <br/>
            <input
                type="password"
                className="block border border-grey-light w-full p-3 rounded mb-4"
                name="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}/>
            <div className="password error"/>
            <br/>
            <button
                type="submit"
                className="w-full text-center py-3 rounded-2xl bg-red-50 hover:bg-red-300 focus:outline-none my-1"
            >Connexion
            </button>

        </form>
    );
};

export default SignIn;

